export const crabCurry = {
  id: "crabCurry",
  link: "/#/recipes/recipes/crabCurry",
  name: "Crab Curry",
  cuisine: "Alethi Men's Food",
  summary: "Savory curry with softshell crabs, served over rice",
  inspiration: null,
  quantity: "4 servings ",
  time: "1 hour",
  notes:
    "This is definitely a nontraditional way to use softshell crabs. I looked up various crab curries and fell in love with the idea of using as much of the crab as possible. If you'd not feeling quite this adventurous, feel free to replace the softshell crabs with crab meat or legs.",
  quotes:
    "I have a birthmark on the back of my left thigh, and I had crab curry for breakfast. Anything else you need to know? (Oathbringer ch 13)",
  image: "https://jozomby-public.s3.amazonaws.com/recipes/crab-curry-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "crab",
          display: "1 lb softshell crabs"
        },
        {
          item: "coconut",
          display: "1 tbsp coconut oil"
        },
        {
          item: "onion",
          display: "2 onions"
        },
        {
          item: "garlicClove",
          display: "4 cloves garlic"
        },
        {
          item: "ginger",
          display: "2 inches ginger"
        },
        {
          item: "bellPepper",
          display: "1 red bell pepper"
        },
        {
          item: "hotPeppers",
          display: "2 4 oz. cans diced green chiles"
        },
        {
          item: "garamMasala",
          display: "1 tsp garam masala"
        },
        {
          item: "cumin",
          display: "1/2 tsp ground cumin"
        },
        {
          item: "turmeric",
          display: "1/2 tsp ground turmeric"
        },
        {
          item: "gochugaru",
          display: "2 tbsp gochugaru"
        },
        {
          item: "salt",
          display: "2 tsp salt"
        },
        {
          item: "water",
          display: "2 cups water"
        },
        {
          item: "fishSauce",
          display: "1 tsp fish sauce"
        },
        {
          item: "rice",
          display: "2 cups basmati rice, optional"
        }
      ]
    }
  ],
  steps: [
    "Clean the softshell crabs. Melt 1 tbsp coconut oil in a large pan over medium high heat. Peel and chop the onions, then add them to the pan. Cook until somewhat browned, about 15 minutes.",
    "Peel and mince the garlic. Peel and grate the ginger. Dice the bell pepper. Add the garlic, ginger, bell pepper, green chiles, garam masala, cumin, turmeric, gochugaru and salt to the pan. Stir and cook for 2 minutes.",
    "Start cooking the rice. Cook the rice as directed by your rice cooker, using the water-to-rice ratio printed on the package.",
    "Add 2 cups water and the fish sauce to the pan. Bring to a boil, then reduce heat to simmer. Cover and simmer for 10 minutes. Use an immersion blender to blend it to a thick and chunky sauce. You don't need to liquify every chunk.",
    "Add the crabs to then pan. Stir to coat in sauce. Cover and simmer on medium low for 7 minutes until crabs are cooked, stirring occasionally.",
    "Remove from heat and let sit a few minutes before serving. Serve with rice."
  ]
}
